import { Vector3 } from 'three'

export default
{
    COLORS:
    {
        bgColor: 0xfcf8f7, // Color of the background
        map: 0xfaf2f0, // Color of the terrain
        lot: 0xfaf2f0, // 0xb6dacd, // Color of the lots when unlighted
        building: 0xdddddd, // Color of the buildings when unlighted
        highlightedLot: 0xdfc53d, // 0xedd28f, // Color of the lots when highlighted
        wireframe: 0x000000, // Color of the mesh wireframe

        paletteGreen: 0x89a669, // Green from the clients palette
        paletteGreenLight: 0xacc095, // Light green from the clients palette
        paletteGreenLightest: 0xcdd9bf, // Light green for the external fields
        paletteBlue: 0xe1f3f6, // Blue from the clients palette
        paletteGold: 0xedd28f, // Gold from the clients palette
    },
    SCENE:
    {
        lightPosition: new Vector3(-0.97, 0.88, 1.19), // Position of the directional light
        minBoundary: new Vector3( -3.0, - 0.5, -3.0), // World min boundary
        maxBoundary: new Vector3(  3.0,   3.0,  3.0), // World max boundary
    },
    CAMERA:
    {
        fov: 35, // Camera field of view
        clipNear: 0.01, // Camera near clipping plane
        clipFar: 8, // Camera far clipping plane

        startPosition: new Vector3(0.0, 0.71, 1.31), // Camera start position
        targetStartPosition: new Vector3(0.0, 0.17, 0.15), // Camera OrbitControls target start position

        // controlsMinDistDesktop: 0.15, controlsMinDistMobile: 0.25, // OrbitControls zoom min distance
        controlsMinDistDesktop: 0.60, controlsMinDistMobile: 0.70, // OrbitControls zoom min distance
        controlsMaxDistDesktop: 3.00, controlsMaxDistMobile: 5.00, // OrbitControls zoom max distance

        clickAnimDuration: 2, // Seconds of duration of the zoom animation
        clickDistanceDesktop: 0.6, clickDistanceMobile: 0.7, // The distance between the camera and the clicked object, at the end of the click animation
     },
    RAYCAST:
    {
        raycastInterval: 150, // 100, // Milliseconds of wait between raycast checks
        textAnimDuration: 0.75, // Duration of the text appearance animation
        textStartY: 0.2, // Text animation start Y (offset from the intersection point)
        textEndY: 0.1 // Text animation end Y (offset from the intersection point)
    },
    TERRAIN_TYPES:
    {
        None: 0, // User pointed outside the terrain
        Map: 1, // User pointed on a terrain
        Lot: 2, // User pointed on a lot
        Forest: 3, // User pointed on the park
        BuildingBase: 4, // User pointed on the terrain that contains the buildings
        TreeBase: 5, // User pointed on the terrains that contains trees
    },
    TREES:
    {
        treesBushesPercentage: 0.80, // Percentage of trees (0) in relation to the bushes (1)

        nOfTreesInWoods: 2000, // 4000, // Total number of trees in the woods
        nOfTreesInPark: 150, // 300, // Total number of trees in the park
        nOfTreesScattered: 30, // 100, // Number of trees scattered around
        nOfBushesScattered: 100, // 300, // Number of bushes scattered around

        bushBaseScale: 0.012, // Initial dimension of the bushes
        bushScaleRandomRange: 0.6, // Bushes scale randomization factor

        treeBaseScale: 0.014, // Initial dimension of the trees
        treeBaseHeight: 2, // Initial height of the trees
        treeScaleRandomRange: 0.3, // Trees scale randomization factor
    },
    VARS:
    {
    }
}